import { render, staticRenderFns } from "./ot-tabs-wrapper.vue?vue&type=template&id=20d1715e&scoped=true&"
import script from "./ot-tabs-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-tabs-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-tabs-wrapper.vue?vue&type=style&index=0&id=20d1715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1715e",
  null
  
)

export default component.exports